<template>
  <div class="collection">
    <div class="collection-box">
      <div class="collection-content">
        <div class="collection-content-left">
          <div class="collection-content-one">图上管理 \ 数据可视化 \ 掌上征收 \ 协同作业</div>
          <div class="collection-content-two">一图规划 多方作业</div>
          <div class="collection-content-three">房屋征收综合管理系统</div>
          <div
            class="collection-content-four"
            style=" margin-top: 30px;"
          >基于城市更新和土地整备、房屋征收、棚户区改造等征收业务，供政府相关职能</div>
          <div class="collection-content-four">部门（城市更新和土地整备局、征收办等）、征收服务公司、第三方公司（测</div>
          <div class="collection-content-four">绘、监理、评估、督导等）多机构、多单位协同作业的一站式信息化管理平台</div>
          <div class="collection-btn" @click="toLogin">点击登录</div>
        </div>
        <div class="collection-content-right">
          <img src="../assets/img/tuzheng_011.png" />
        </div>
      </div>
    </div>
    <div class="collection-content-box">
      <div class="collection-one">
        <div class="collection-one-left" id="wrapper-text">
          <div class="text-one">区县图上管理</div>
          <div
            class="text-two"
          >一张图征收管理，利用先进的GIS地图架构，实现全方位的征收一张图。配合遥感影像三维建模见证正式发展历史，可视化数据驾驶舱实时反馈，规范征收数据全面电子化。</div>
        </div>
        <div class="collection-one-right" id="wrapper-img">
          <img src="../assets/img/tuzheng_02.png" />
        </div>
      </div>
      <div class="collection-two">
        <div class="collection-two-left" id="wrapper-img1">
          <img src="../assets/img/tuzheng_03.png" />
        </div>
        <div class="collection-two-right" id="wrapper-text1">
          <div class="text-one">数据可视化</div>
          <div
            class="text-two"
          >通过大数据可视化技术，展示项目进度、资金收支情况、土地整备任务量、房源安置情况等汇总信息，达到高效、科学的制定土地整备及房屋征收任务计划、拆迁补偿方案，把控资金预算多，可自定义配置相关维度。</div>
        </div>
      </div>
      <div class="collection-three">
        <div class="collection-three-left" id="wrapper-text2">
          <div class="text-one">实时项目进度监控</div>
          <div class="text-two">根据项目总量制定年度任务量情况，精准分解各街道任务，实时更新项目进展完成情况,可使用电脑网页端、手机小程序实时把控项目进度与情况</div>
        </div>
        <div class="collection-three-right" id="wrapper-img2">
          <img src="../assets/img/tuzheng_04.png" />
        </div>
      </div>
      <div class="collection-two">
        <div class="collection-two-left" id="wrapper-img3">
          <img src="../assets/img/tuzheng_05.png" />
        </div>
        <div class="collection-two-right" id="wrapper-text3">
          <div class="text-one">协同作业</div>
          <div class="text-two">不同职能类型的项目入围机构在线系统录入各自业务表单数据，实现信息互通，解决数据孤岛问题。</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    var x = document.getElementById('wrapper-img');
    x.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight collection-one-right'
    );
    var y = document.getElementById('wrapper-text');
    y.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft collection-one-left'
    );
    var x1 = document.getElementById('wrapper-img1');
    x1.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft collection-two-left'
    );
    var y1 = document.getElementById('wrapper-text1');
    y1.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight collection-two-right'
    );
    var x2 = document.getElementById('wrapper-img2');
    x2.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight collection-three-right'
    );
    var y2 = document.getElementById('wrapper-text2');
    y2.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft collection-three-left'
    );
    var x3 = document.getElementById('wrapper-img3');
    x3.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft collection-two-left'
    );
    var y3 = document.getElementById('wrapper-text3');
    y3.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight collection-two-right'
    );
  },
  methods: {
    toLogin() {
      window.open('https://zs.yunzhengshou.com');
    }
  }
};
</script>
<style>
.collection {
  width: 100%;
}
.collection-box {
  display: flex;
  width: 100%;
  height: 650px;
  background: url('../assets/img/blue.png') no-repeat center;
  background-size: 100% 650px;
  overflow: hidden;
}
.collection-content {
  display: flex;
  width: 1500px;
  height: 650px;
  margin: auto;
  overflow: hidden;
}
.collection-content-left {
  width: 50%;
  margin-top: 70px;
  margin-left: 30px;
}
.collection-content-one {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #ffffff;
}
.collection-content-two {
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  color: #ffffff;
  margin-top: 34px;
}
.collection-content-three {
  margin-top: 20px;
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 72px;
  color: #ffffff;
}
.collection-content-four {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  color: #ffffff;
  line-height: 40px;
}
.collection-btn {
  width: 110px;
  height: 40px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  border: 1px solid rgba(0, 189, 183, 1);
  text-align: center;
  line-height: 40px;
  color: rgba(0, 189, 183, 1);
  cursor: pointer;
  margin-top: 42px;
}
.collection-btn:hover {
  color: rgb(41, 146, 151);
}
.collection-content-right {
  width: 50%;
}
.collection-content-right img {
  width: 100%;
}
.collection-content-box {
  width: 1500px;
  margin: auto;
  overflow: hidden;
}
.collection-one,
.collection-two,
.collection-three {
  display: flex;
  padding: 50px 64px;
}
.text-one {
  font-family: '微软雅黑';
  font-weight: 410;
  font-style: normal;
  font-size: 48px;
  color: #495362;
}
.text-two {
  margin-top: 10px;
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  color: #495362;
  line-height: 50px;
}
.collection-one-left {
  padding-right: 100px;
  width: 50%;
}
.collection-three-left {
  width: 50%;
  padding-right: 100px;
}
.collection-one-right {
  width: 50%;
}
.collection-one-right img {
  width: 100%;
}
.collection-two-left,.collection-two-right {
  width: 50%;
}
.collection-two-left {
  padding-right: 100px;
}
.collection-two-left img {
  width: 100%;
}
.collection-three-right {
  width: 50%;
}
.collection-three-right img {
  width: 100%;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .collection-content,
  .collection-content-box {
    width: 1200px !important;
  }
  .collection-content-two {
    font-size: 36px !important;
  }
  .collection-content-four {
    font-size: 16px !important;
  }
  .text-one {
    font-size: 36px !important;
  }
  .text-two {
    font-size: 20px !important;
  }
  .collection-content-three {
    font-size: 48px!important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/collection.vue